import React, { useEffect, useState } from 'react';

const withBeelineStore = (Comp) => {
  const WithBeelineStoreHOC = (props) => {
    const [externalStore, setExternalStore] = useState({});

    useEffect(() => {
      const intervalId = setInterval(() => {
        const beelineStore = window.beeline.store;
        if (beelineStore) {
          setExternalStore(beelineStore);
          clearInterval(intervalId);
        }
      }, 50);

      return () => clearInterval(intervalId);
    }, []);

    return <Comp store={externalStore} {...props} />;
  };

  return WithBeelineStoreHOC;
};

export default withBeelineStore;
